<template>
  <div class="icon" @mouseover="hoverOver(name)" @mouseleave="hoverLeave">
    <img :src="'/img/rooms/' + name + '.svg'" class="img" />
    <div class="property" v-show="hover">
      {{ descriptionProperty }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  name: string
}>()

// State
const hover = ref(false)
// @ts-ignore
const descriptionProperty = computed(() => property[props.name])

// Property translations
const property = {
  bathroom: "Ванная комната",
  wifi: "Wi-Fi",
  tv: "Телевизор",
  hair_dryer: "Фен",
  bath_accessories: "Банные принадлежности",
  teapot: "Чайник",
  telephone: "Телефон",
  safe: "Сейф",
  balcon: "Балкон",
  jacuzzi: "Джакузи",
  parking: "Парковка",
  breakfast: "Завтрак"
}

// Methods
const hoverOver = (name: string) => {
  descriptionProperty.value = property[name as keyof typeof property]
  hover.value = true
}

const hoverLeave = () => {
  hover.value = false
}
</script>

<style scoped>
.icon {
  position: relative;
  width: 27px;
  height: 27px;
  margin-right: 18.5px;
}

.property {
  position: absolute;
  top: 3.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  padding: 5px 8px 6px;
  line-height: 0.7;
  white-space: nowrap;
  background: #ffffff;
  border: 0.4px solid #707070;
}

.img {
  width: 27px;
  height: 27px;
}
</style>
